module.exports = __webpack_public_path__ + "static/img/service-big.a1fdf7b3.png";